export const API_PATH_ApiLanePlanningDelete = '/services/lane-planning/apiLanePlanningDelete';
